




















import axios from 'axios';
import Vue from 'vue';

interface LSAItem {
  type: string;
  id: string;
  start: string;
  end: string;
  article_id: number;
  category_id: string;
  title: string;
  image: string;
  status?: string;
}

interface LSAResponse {
  status: string;
  items: LSAItem[];
}

interface Data {
  activeStream: LSAItem | null;
  lsaUrl: string;
  streams: Array<any>;
}

interface Methods {
  clearInterval: () => void;
  getActiveStream: () => void;
  handleClick: () => void;
  handleClose: () => void;
}

interface Computed {
  isMobileOrTablet: boolean;
}

interface lsaWindow extends Window {
  _dlf: any;
  ga: any;
  geoipdata: any;
  lsa: any;
}

declare let window: lsaWindow;

export default Vue.extend<Data, Methods, Computed, unknown>({
  data() {
    return {
      activeStream: null,
      lsaUrl: 'https://www.delfi.lt/misc/video/ajax.php?get=live-stream-announcement-v2',
      streams: [],
    };
  },
  computed: {
    isMobileOrTablet() {
      return (typeof window !== 'undefined' && window.innerWidth <= 991) || false;
    },
  },
  watch: {
    activeStream(value) {
      if (value && this.activeStream) {
        if (!this.isMobileOrTablet) {
          var player = document.createElement('script');
          player.async = true;
          player.dataset.mute = '1';
          player.dataset.width = '280';
          player.dataset.where = `lsa-${this.activeStream.id}-content`;
          player.dataset.type = 'LSA';

          if (this.activeStream.type === 'dvideo') {
            player.dataset.autoplay = 'preview';
            player.dataset.id = this.activeStream.id;
            player.src = 'https://g.delfi.lt/components/video/player.js';
          }

          if (this.activeStream.type === 'youtube') {
            player.dataset.autoplay = 'true';
            player.dataset.video = this.activeStream.id;
            player.src = 'https://g.delfi.lt/glt/c/delfi-live/yt.js';
          }

          if (this.activeStream.article_id) {
            player.dataset.article = this.activeStream.article_id.toString();
          }

          window.document.head.appendChild(player);
        }

        const expires = new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toUTCString();
        window.document.cookie = `dLSA_${this.activeStream.id}=1;expires=${expires};path=/`;

        window.ga('send', 'event', 'Video', 'teaserPlayerShow');

        this.clearInterval();

        if (this.isMobileOrTablet) {
          setTimeout(
            () => {
              window.document.getElementById(`lsa-${this.activeStream?.id}`)?.classList.add('C-live-stream-announcement--active');
            },
            2000,
            this.activeStream?.id
          );

          setTimeout(
            () => {
              window.document.getElementById(`lsa-${this.activeStream?.id}`)?.classList.remove('C-live-stream-announcement--active');
            },
            10000,
            this.activeStream?.id
          );
        }
      }
    },
  },
  async mounted() {
    if (process.client) {
      if (!/\.lt\/video\//.test(window.location.href)) {
        this.getActiveStream();

        window.lsa = setInterval(() => {
          this.getActiveStream();
        }, 15000);
      }
    }
  },
  methods: {
    clearInterval() {
      if (typeof window.lsa !== undefined) {
        clearInterval(window.lsa);
      }
    },
    async getActiveStream() {
      const { data }: { data: LSAResponse } = await axios.get(this.lsaUrl);
      const items = Object.values(data.items); // Stupid JSON has keys

      if (items.length) {
        items.forEach(item => {
          switch (item.type) {
            case 'youtube': {
              if (item.status == 'live' && window.document.cookie.indexOf(`dLSA_${item.id}`) == -1) {
                this.clearInterval();
                this.activeStream = item;
              }

              break;
            }
            case 'dvideo': {
              const time = Date.now();
              const start = parseInt(item.start) * 1000 + 60000;
              const end = parseInt(item.end) * 1000;

              if (time > start && time < end && window.document.cookie.indexOf(`dLSA_${item.id}`) == -1) {
                this.clearInterval();
                this.activeStream = item;
              }

              break;
            }
          }
        });
      }
    },
    handleClick() {
      if (this.isMobileOrTablet) {
        window.location.href = `https://www.delfi.lt/a/${this.activeStream?.article_id}`;
      } else {
        window.open(`https://www.delfi.lt/a/${this.activeStream?.article_id}`, '_blank');
      }

      window.ga('send', 'event', 'Video', 'teaserPlayerClick');
    },
    handleClose() {
      window.document.getElementById(`lsa-${this.activeStream?.id}`)?.remove();
      window.ga('send', 'event', 'Video', 'teaserPlayerClose');
    },
  },
});
